import { render } from "./WelcomePublicHotelComponent.vue?vue&type=template&id=0a1dcf44"
import script from "./WelcomePublicHotelComponent.vue?vue&type=script&lang=js"
export * from "./WelcomePublicHotelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__